import React, { Component } from "react";
import "./App.css";
import CookieConsent, { Cookies } from "react-cookie-consent";
import Checkbox from "./Checkbox";

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cookieConsentValue: { necessary: "yes", marketing: "yes", analytics: "yes", preferences: "yes", unclassified: "yes" },
      viewState: "start",
      checkboxes: [
        { type: "necessary", selected: true, disabled: true, label: "Noodzakelijk", info: "Deze cookies zijn puur functioneel. De website kan niet goed functioneren zonder deze cookies." },
        { type: "marketing", selected: true, disabled: false, label: "Marketing cookies", info: "Deze cookies houden het surfgedrag bij. Hierbij is het mogelijk om advertenties te tonen die afgestemd zijn op jouw interesses. " },
        { type: "analytics", selected: true, disabled: false, label: "Analytische cookies", info: "Deze cookies verzamelen geanonimiseerde data over gebruik van onze website en helpen ons de website te optimaliseren. " },
        { type: "preferences", selected: true, disabled: false, label: "Voorkeur cookies", info: "Deze cookies zorgen ervoor dat jouw voorkeursinstellingen worden onthouden voor jouw volgende websitebezoek. " },
      ],
    };
  }
  
  selectAllCheckboxes = isSelected => {

    //var newCheckboxes
    let checkboxes = [...this.state.checkboxes];
    this.state.checkboxes.forEach((checkbox, index) => {
      console.dir(checkbox);
      //Exclude disabled checkboxes
      if (!checkbox.disabled) {
        checkboxes[index] = { ...checkboxes[index], selected: isSelected };
      }
    });

    //Save Checkboxes New State
    this.setState({ checkboxes });
  };

  selectAll = () => this.selectAllCheckboxes(true);

  deselectAll = () => this.selectAllCheckboxes(false);

  handleCheckboxChange = changeEvent => {
    //changeEvent.persist();
    const { name } = changeEvent.target;
    //console.dir(changeEvent);

    console.log(name);

    const checkboxValue = changeEvent.target.type === 'checkbox' ? changeEvent.target.checked : changeEvent.target.value;

    //Find Index
    var index = this.state.checkboxes.findIndex(x => x.label === name);

    console.log("Index: " + index);

    //Update Enrty based on index
    if (index === -1) {
      // handle error
      console.log("Checkbox not found");
    } else {
      this.setState({
        checkboxes: [
          ...this.state.checkboxes.slice(0, index),
          Object.assign({}, this.state.checkboxes[index], { selected: checkboxValue }),
          ...this.state.checkboxes.slice(index + 1)
        ]
      });
    }
  };

  handleFormSubmit = () => {
    //formSubmitEvent ? formSubmitEvent.preventDefault() : false;

    this.saveCookiePreferences("chosen")
  };

  createCheckbox = option => (
    <Checkbox
      label={option.label}
      info={option.info}
      isSelected={option.selected}
      disabled={option.disabled}
      onCheckboxChange={this.handleCheckboxChange}
      key={option.type}
      dataType={option.type}
    />
  )
  
  createCheckboxes = () => this.state.checkboxes.map(this.createCheckbox);

  saveCookiePreferences(type) {
    var cookieConsentValue = {};

    this.state.checkboxes.forEach((checkbox, index) => {
      console.dir(checkbox);

      var checkboxValue = (type === "accept") ? true : (type === "decline" ) ? false : checkbox.selected;

      cookieConsentValue[checkbox.type] = (checkboxValue === true) ? "yes" : "no";
    });
    
    console.dir(cookieConsentValue);

    //Save Cookie
    Cookies.set("crux_cookie_dough_preference", JSON.stringify(cookieConsentValue), { expires: 365 });
    
    //Send Data Layer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'cookies_saved',
      'consent': cookieConsentValue /*JSON.stringify(cookieConsentValue)*/,
    });
  }

  render() {

    if (this.state.viewState === "start") {
      return (
        <div className="App">
          <CookieConsent
            flipButtons={false}
            buttonText="Accepteren"
            declineButtonText="Zelf instellen"
            onAccept={() => {
              //Save Cookie Preferences
              this.saveCookiePreferences("accept");
            }}
            debug={false}
            enableDeclineButton
            onDecline={() => {
              this.deselectAll();

              this.setState({ viewState: "select" });
            }}
            cookieName="cruxCookieDough"
            disableStyles={true}
            className="crux-cookie-consent-container"
            containerClasses="crux-cookie-consent-container"
            buttonWrapperClasses="crux-cookie-consent-buttons-wrapper"
            buttonClasses="crux-cookie-consent-button crux-cookie-consent-button-accept"
            declineButtonClasses="crux-cookie-consent-button crux-cookie-consent-button-decline"
            //extraCookieOptions={{ domain: "myexample.com" }}
            expires={365}
          >
            <h1>Wij maken gebruik van cookies</h1>

            <p>Leuk dat je onze website bezoekt! Wij maken op onze website gebruik van cookies om jouw voorkeuren op te slaan, voor het bijhouden van statistieken, en voor marketingdoeleinden. Hierbij wordt ook informatie met onze social media, advertentie- en analytics partners gedeeld die zij kunnen combineren met andere gegevens die jij bij hen hebt achtergelaten.</p>

          </CookieConsent>
        </div>
      );
    } else if (this.state.viewState === "select") {
      return (
        <div className="App">
          <h1></h1>
          <CookieConsent
            flipButtons={false}
            buttonText="Sla voorkeuren op"
            declineButtonText="Afwijzen"
            onAccept={() => {
              //Handle Form Submit
              this.handleFormSubmit();
            }}
            debug={true}
            enableDeclineButton={false}
            onDecline={() => {
              //Save Cookie Preferences
              this.saveCookiePreferences("decline");
            }}
            cookieName="cruxCookieDough"
            disableStyles={true}
            className="crux-cookie-consent-container"
            containerClasses="crux-cookie-consent-container"
            buttonWrapperClasses="crux-cookie-consent-buttons-wrapper"
            buttonClasses="crux-cookie-consent-button crux-cookie-consent-button-accept"
            declineButtonClasses="crux-cookie-consent-button crux-cookie-consent-button-decline"
            //extraCookieOptions={{ domain: "myexample.com" }}
            expires={365}
          >
            <div className="crux-cookie-select-container">
              <div className="crux-cookie-select-block">
                <h1>Cookie instellingen</h1>

                <p> Cookies zijn kleine tekstbestanden die gebruikt kunnen worden door websites om de gebruikerservaringen te verbeteren. Volgens de wet mogen wij cookies op jouw apparaat opslaan als zij strikt noodzakelijk zijn voor het gebruiken van deze website. Voor alle andere soorten cookies hebben wij jouw toestemming nodig.

Deze website gebruikt verschillende soorten cookies. Sommige cookies worden geplaatst door diensten van derden die op onze pagina's worden gebruikt. </p>

                <h3>Geef je toestemming om de geselecteerde cookies te gebruiken voor een optimale ervaring? </h3>
              </div>
              <div className="crux-cookie-select-block">
                <form>
                  {this.createCheckboxes()}

                  <div className="crux-cookie-select-button-container">

                    <button
                      type="button"
                      className="crux-cookie-consent-button crux-cookie-consent-button-decline"
                      onClick={this.selectAll}
                      label="Test"
                    >
                      Selecteer alles
                </button>
                    <button
                      type="button"
                      className="crux-cookie-consent-button crux-cookie-consent-button-decline"
                      onClick={this.deselectAll}
                    >
                      Deselecteer alles
                </button>
                    {
                      /*b<utton type="submit" className="btn btn-primary">
                        Save
                      </button>*/
                    }
                  </div>
                </form>
              </div>
            </div>
          </CookieConsent>
        </div>
      )
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js